import { type SkeletorResponse } from '@store/skeletor/types';

const extractDataFromResponse = <TData>(response: SkeletorResponse<TData>) => {
  return response.data;
};

export { extractDataFromResponse };
